import { axiosClient } from "./axios";

export async function getProvince() {
  try {
    const response = await axiosClient.get('master/provinces');
    return response.data.data;
  } catch (error) {
    console.error('Gagal mengambil data provinsi:', error);
    return []; 
  }
}

export async function getCity(_selectedProvince) {
  try {
    const response = await axiosClient.get(`/master/kabupaten/${_selectedProvince}`);
    return response.data.data;
  } catch (error) {
    console.error('Gagal mengambil data kota:', error);
    return []; 
  }
}

export async function postRegister(
  name,
  phone,
  instagram,
  email,
  province,
  city,
  school,
  agreement,
  programCode
) {
  try {
    const formData = new FormData();
    formData.append('nama_lengkap', name);
    formData.append('no_wa', phone);
    formData.append('instagram', instagram);
    formData.append('email', email);
    formData.append('province_id', province);
    formData.append('kabupaten_id', city);
    formData.append('school', school);
    formData.append('agreement', agreement);
    formData.append('program_code', programCode);
    
    const response = await axiosClient.post('ihms/register',formData); 
    return response.data;
  } catch (error) {
    console.error('Gagal submit data:', error);
    throw error; 
  }
}